module.exports = __webpack_public_path__ + "static/media/Stock_Transfer_Template_1.4be0a093.png";